import * as React from 'react'
import { useParams } from 'react-router-dom'
import { MarketingLayout } from '../components/marketing-layout'
import { MarketingPageContainer, PageTitle, PageSubtitle } from '../styles/marketing.styles'
import { blogPosts } from '../data/blog-posts'

export const BlogPostPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>()
  const post = slug ? blogPosts.find((p) => p.slug === slug) : null

  if (!post) {
    return (
      <MarketingLayout>
        <MarketingPageContainer>
          <PageTitle>Post not found</PageTitle>
          <PageSubtitle>The blog post you are looking for does not exist.</PageSubtitle>
        </MarketingPageContainer>
      </MarketingLayout>
    )
  }

  return (
    <MarketingLayout>
      <MarketingPageContainer>
        <PageTitle>{post.title}</PageTitle>
        <PageSubtitle>{post.date} &middot; {post.author}</PageSubtitle>
        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </MarketingPageContainer>
    </MarketingLayout>
  )
}
